import React, { useRef, useCallback } from 'react';
import { useOutsideClick, useTranslation } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { autoBetStore } from '../../store/autoBetStore';
import { gameStore } from '../../store/gameStore';
import { AUTO_BET_COUNTS, INFINITY_AUTO_BET } from '../../enums/constants';

const handleAutoBetCount = (item) => {
  if (!item) {
    return 'OFF';
  }
  if (item === INFINITY_AUTO_BET) {
    return '∞';
  }
  return item;
};

export const AutoBetSection = observer(() => {
  const { autoBetCount, setAutoBetCount } = autoBetStore;
  const { isBetsClosed } = gameStore;
  const autoBetRef = useRef();
  const t = useTranslation();
  const [opened, handleClick] = useOutsideClick(autoBetRef);
  const handleSelectAutoBetCount = useCallback(
    (count) => setAutoBetCount(count),
    [setAutoBetCount]
  );

  return (
    <div
      onClick={handleClick}
      className={`tb-bet-amount-wrp right ${isBetsClosed ? 'passive' : ''}`}
      ref={autoBetRef}
    >
      <p className='tb-bet-amount-txt'>
        {autoBetCount ? handleAutoBetCount(autoBetCount) : t(handleAutoBetCount(autoBetCount))}
      </p>
      <div className='tb-bet-amount-circle-icon right'>
        <i className='icon-auto-belote' />
      </div>
      <div className={`tb-bet-amount-popup ${opened ? 'active' : ''}`}>
        {' '}
        {/* add active class */}
        <div className='tb-bet-amount-popup-inner'>
          <div className='tb-bet-amount-popup-inside'>
            {AUTO_BET_COUNTS.map((item) => (
              <span
                onClick={() => handleSelectAutoBetCount(item)}
                key={item}
                className={`tb-bet-amount-popup-number ${autoBetCount === item ? 'active' : ''}`}
              >
                {handleAutoBetCount(item)}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});
